import { call, debounce, put } from 'redux-saga/effects';
import { GAME_MOVED, QUIET_MS, SEE_GAME } from './constants';
import { setGamesWithNewMoves } from './actions';
import { getGames } from '../Games/actions';
import { seen } from '../services/game';

// The games list counts each game's new moves: on it, a move brings the list again, once the burst is over.
function* refreshGamesTask() {
  if (window.location.pathname === '/games') {
    yield put(getGames());
  }
}

function* seeGameTask(action) {
  const { gameId, version } = action.payload;
  yield put(setGamesWithNewMoves(yield call(seen, gameId, version)));
}

export default [
  function* gameMovedWatcher() { yield debounce(QUIET_MS, GAME_MOVED, refreshGamesTask); },
  function* seeGameWatcher() { yield debounce(QUIET_MS, SEE_GAME, seeGameTask); },
];
